import React from "react";
import PropTypes from "prop-types";
import {Button} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {styled} from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {ALERT} from "../resources/environment";
import {MaterialDesignContent, SnackbarProvider} from "notistack";

const StyledMaterialDesignContent = styled(MaterialDesignContent)(({theme}) => ({
  "&.notistack-MuiContent-success": {
    borderRadius: 0,
    color: "rgb(30, 70, 32)",
    backgroundColor: "rgb(237, 247, 237)",
    "& svg": {color: theme.palette.success.main},
  },
  "&.notistack-MuiContent-warning": {
    borderRadius: 0,
    color: "rgb(102, 60, 0)",
    backgroundColor: "rgb(255, 244, 229)",
    "& svg": {color: theme.palette.warning.main},
  },
  "&.notistack-MuiContent-error": {
    borderRadius: 0,
    color: "rgb(97, 26, 21)",
    backgroundColor: "rgb(253, 236, 234)",
    "& svg": {color: theme.palette.error.main},
  },
  "&.notistack-MuiContent-info": {
    borderRadius: 0,
    color: "rgb(13, 60, 97)",
    backgroundColor: "rgb(232, 244, 253)",
    "& svg": {color: theme.palette.info.main},
  },
}));

const useAlertProviderStyles = makeStyles()((theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
}));

const AlertProvider = ({children, maxSnack}) => {
  const {classes} = useAlertProviderStyles();
  const alertRef = React.createRef();

  return (
    <SnackbarProvider
      ref={alertRef}
      maxSnack={maxSnack || ALERT.maxSnack}
      preventDuplicate
      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
      autoHideDuration={ALERT.duration}
      action={(key) => (
        <Button
          onClick={() => alertRef.current.closeSnackbar(key)}
          color="grey"
        >
          <CloseIcon />
        </Button>
      )}
      iconVariant={{
        success: <CheckCircleOutlinedIcon className={classes.icon} />,
        error: <ErrorOutlineOutlinedIcon className={classes.icon} />,
        warning: <ReportProblemOutlinedIcon className={classes.icon} />,
        info: <InfoOutlinedIcon className={classes.icon} />,
      }}
      Components={{
        success: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
      }}
    >
      {children}
    </SnackbarProvider>
  );
};

AlertProvider.propTypes = {
  children: PropTypes.any.isRequired,
  maxSnack: PropTypes.number,
};

export default AlertProvider;
